<template>
  <div>
    <van-sticky>
      <van-nav-bar
        style="background-color: #3f78f6; margin-bottom: 0rem; border: 0"
        title=""
        left-text=""
        left-arrow
        @click-left="onClickLeft"
      >
        <template #title>
          <span style="color: white; font-size: 0.4rem">信息提醒</span>
        </template>
        <template #left>
          <van-icon name="arrow-left" color="white" size="18" />
        </template>
      </van-nav-bar>
    </van-sticky>
    <van-tabs color=" #3f78f6" sticky @click="onClick">
      <van-tab title="未归寝">
        <van-search
          v-model="value"
          shape="round"
          right-icon="search"
          left-icon=""
          placeholder="请输入学生姓名或学号"
          @search="onSearch"
        />
        <!-- 内容循环操作-->
        <section class="van-doc-demo-section">
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
          >
            <div class="locusItems" v-for="item in list" :key="item.id">
              <table border="0" style="font-size: 0.4rem; margin: 0 0.5rem">
                <tr>
                  <td colspan="3">姓名：{{ item.name }}</td>
                </tr>
                <tr>
                  <td style="font-size: 0.36rem; height: 1rem; color: #666666">
                    {{ "学号：" + item.personal_number }}
                  </td>
                  <!-- <td
                style="
                  text-align: center;
                  width: 3rem;
                  font-size: 0.36rem;
                  color: #666666;
                "
              >
                {{ "寝室：" + item.froom }}
              </td>-->
                  <td>
                    <van-tag
                      round
                      type="primary"
                      style="
                        font-size: 0.4rem;
                        width: 2rem;
                        height: 0.6rem;
                        text-align: center;
                        padding-top: 0.2rem;
                        display: block;
                        color: white;
                        background-color: #3f78f6;
                        position: absolute;
                        top: 1rem;
                        right: 01rem;
                        left: 7.2rem;
                        border-radius: 0.585185rem;
                      "
                      @click="
                        close(item.personal_number, item.messageState, 'WG',
                          item.backContent)
                      "
                      >{{ item.messageState }}</van-tag
                    >
                  </td>
                </tr>
              </table>
            </div>
          </van-list>
          <div style="margin: 16px; margin-top: 40px">
            <van-button round block type="info" @click="yjclick('WG')">
              一键发送
            </van-button>
          </div>
        </section>
      </van-tab>
      <van-tab title="迟到">
        <van-search
          v-model="value"
          shape="round"
          right-icon="search"
          left-icon=""
          placeholder="请输入学生姓名或学号"
          @search="onSearch"
        />
        <!-- 内容循环操作-->
        <section class="van-doc-demo-section">
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
          >
            <div class="locusItems" v-for="item in listcd" :key="item.id">
              <table border="0" style="font-size: 0.4rem; margin: 0 0.5rem">
                <tr>
                  <td colspan="3">姓名：{{ item.name }}</td>
                </tr>
                <tr>
                  <td style="font-size: 0.36rem; height: 1rem; color: #666666">
                    {{ "学号：" + item.personal_number }}
                  </td>
                  <!-- <td
                style="
                  text-align: center;
                  width: 3rem;
                  font-size: 0.36rem;
                  color: #666666;
                "
              >
                {{ "寝室：" + item.froom }}
              </td>-->
                  <td>
                    <van-tag
                      round
                      type="primary"
                      style="
                        font-size: 0.4rem;
                        width: 2rem;
                        height: 0.6rem;
                        text-align: center;
                        padding-top: 0.2rem;
                        display: block;
                        color: white;
                        background-color: #3f78f6;
                        position: absolute;
                        top: 1rem;
                        right: 01rem;
                        left: 7.2rem;
                        border-radius: 0.585185rem;
                      "
                      @click="
                        close(item.personal_number, item.messageState, 'CD',
                          item.backContent)
                      "
                      >{{ item.messageState }}</van-tag
                    >
                  </td>
                </tr>
              </table>
            </div>
          </van-list>
          <div style="margin: 16px; margin-top: 40px">
            <van-button round block type="info" @click="yjclick('CD')">
              一键发送
            </van-button>
          </div>
        </section>
      </van-tab>
      <van-tab title="请假超时">
        <van-search
          v-model="value"
          shape="round"
          right-icon="search"
          left-icon=""
          placeholder="请输入学生姓名或学号"
          @search="onSearch"
        />
        <!-- 内容循环操作-->
        <section class="van-doc-demo-section">
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
          >
            <div class="locusItems" v-for="item in listcs" :key="item.id">
              <table border="0" style="font-size: 0.4rem; margin: 0 0.5rem">
                <tr>
                  <td colspan="3">姓名：{{ item.name }}</td>
                </tr>
                <tr>
                  <td style="font-size: 0.36rem; height: 1rem; color: #666666">
                    {{ "学号：" + item.personal_number }}
                  </td>
                  <!-- <td
                style="
                  text-align: center;
                  width: 3rem;
                  font-size: 0.36rem;
                  color: #666666;
                "
              >
                {{ "寝室：" + item.froom }}
              </td>-->
                  <td>
                    <van-tag
                      round
                      type="primary"
                      style="
                        font-size: 0.4rem;
                        width: 2rem;
                        height: 0.6rem;
                        text-align: center;
                        padding-top: 0.2rem;
                        display: block;
                        color: white;
                        background-color: #3f78f6;
                        position: absolute;
                        top: 1rem;
                        right: 01rem;
                        left: 7.2rem;
                        border-radius: 0.585185rem;
                      "
                      @click="
                        close(
                          item.personal_number,
                          item.messageState,
                          'CS',
                          item.backContent
                        )
                      "
                      >{{ item.messageState }}</van-tag
                    >
                  </td>
                </tr>
              </table>
            </div>
          </van-list>
          <div style="margin: 16px; margin-top: 40px">
            <van-button round block type="info" @click="yjclick('CS')">
              一键发送
            </van-button>
          </div>
        </section>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: 0,
      value: "",
      code: "",
      title: "",
      checked: false,
      loading: false,
      finished: false,
      list: [],
      listcd: [],
      listcs: [],
      student: "",
      page: "",
      xiaoqu: "",
    };
  },
  created() {
    this.student = this.$route.query.student;
    this.page = this.$route.query.page;
    this.xiaoqu = this.$route.query.xiaoqu;
    console.log(
      "传递过来得学生ID：" + this.student + "和默认轮播定位：" + this.page
    );
    this.init();
  },
  methods: {
    onClick(name, title) {
      this.title = title;
      this.value = "";
      if (title == "迟到") {
        var params_jsoncd = {
          userid: this.code,
          action: "GQList",
          param1: "detailCD",
          param2: "",
          param3: "",
          param4: "",
          param5: "",
        };
        this.$http.post("/web/list", params_jsoncd).then(function (res) {
          console.log(res.data["rows"]);
          this.listcd = res.data["rows"];
        });
      } else if (title == "未归寝") {
        var params_jsonwg = {
          userid: this.code,
          action: "GQList",
          param1: "detailWG",
          param2: "",
          param3: "",
          param4: "",
          param5: "",
        };
        this.$http.post("/web/list", params_jsonwg).then(function (res) {
          console.log(res.data["rows"]);
          this.list = res.data["rows"];
        });
      } else if (title == "请假超时") {
        var params_jsoncs = {
          userid: this.code,
          action: "GQList",
          param1: "detailCS",
          param2: "",
          param3: "",
          param4: "",
          param5: "",
        };
        this.$http.post("/web/list", params_jsoncs).then(function (res) {
          console.log(res.data["rows"]);
          this.listcs = res.data["rows"];
        });
      }
    },
    init() {
      console.log("页面初始化Init");
      var json = window.localStorage.getItem("User");
      var jsonObj = JSON.parse(json);
      var code;
      if (jsonObj[0]["shenfen"] == "老师") {
        code = jsonObj[0]["number"];
      } else if (jsonObj[0]["shenfen"] == "学生") {
        code = jsonObj[0]["number"];
      } else {
        code = jsonObj[0]["phone"];
      }
      this.code = code;
      var params_json = {
        userid: code,
        action: "GQList",
        param1: "detailWG",
        param2: "",
        param3: "",
        param4: "",
        param5: "",
      };

      this.$http.post("/web/list", params_json).then(function (res) {
        console.log(res.data["rows"]);
        this.list = res.data["rows"];
      });
      this.onLoad();
    },
    onClickLeft() {
      this.$router.push({
        path: "Index",
        query: {
          page: this.page,
        },
      });
    },
    onLoad() {
      // 异步更新数据
      // setTimeout 仅做示例，真实场景中一般为 ajax 请求
      setTimeout(() => {
        // 加载状态结束
        this.loading = false;

        // 数据全部加载完成
        if (this.list.length >= this.list.length) {
          this.finished = true;
        }
      }, 1000);
    },

    close(id, type, flg, backContent) {
      if (type == "发送通知") {
        var params_json = {
          userid: this.code,
          action: "notice",
          param1: id,
          param2: flg,
          param3: "",
          param4: "",
          param5: "",
        };
        console.log(params_json);
        this.$http.post("/web/save", params_json).then(function (res) {
          let obj = res.data;
          if (obj.msg == "0") {
            this.$notify({
              type: "success",
              message: "通知发送成功!",
            });
            this.init();
          } else {
            this.$notify({
              type: "warning",
              message: "通知发送失败!",
            });
            this.init();
          }
        });
      } else if (type == "已回复") {
        this.$dialog
          .alert({
            title: "回复内容",
            message: backContent,
          })
          .then(() => {
            // on close
          });
      } else {
        return;
      }
    },
    onSearch(val) {
      console.log(val);
      var json = window.localStorage.getItem("User");
      var jsonObj = JSON.parse(json);
      var code;
      if (jsonObj[0]["shenfen"] == "老师") {
        code = jsonObj[0]["number"];
      } else if (jsonObj[0]["shenfen"] == "学生") {
        code = jsonObj[0]["number"];
      } else {
        code = jsonObj[0]["phone"];
      }
      this.code = code;
      var name = "";
      if (this.title == "未归寝" || this.title == "") {
        name = "detailWG";
      } else if (this.title == "迟到") {
        name = "detailCD";
      } else if (this.title == "请假超时") {
        name = "detailCS";
      }
      var params_json = {
        userid: code,
        action: "GQList",
        param1: name,
        param2: val,
        param3: "",
        param4: "",
        param5: "",
      };
      this.$http.post("/web/list", params_json).then(function (res) {
        console.log(res.data["rows"]);
        if (this.title == "未归寝" || this.title == "") {
          this.list = res.data["rows"];
        } else if (this.title == "迟到") {
          this.listcd = res.data["rows"];
        } else if (this.title == "请假超时") {
          this.listcs = res.data["rows"];
        }
      });
      this.onLoad();
    },
    yjclick(flg) {
      var num = "";
      if (flg == "WG") {
        if (this.list.length > 0) {
          for (var i in this.list) {
            if (this.list[i]["messageState"] == "发送通知") {
              num += this.list[i]["personal_number"] + ",";
            }
          }
        } else {
          return;
        }
      } else if (flg == "CD") {
        if (this.listcd.length > 0) {
          for (var c in this.listcd) {
            if (this.listcd[c]["messageState"] == "发送通知") {
              num += this.listcd[c]["personal_number"] + ",";
            }
          }
        } else {
          return;
        }
      } else {
        if (this.listcs.length > 0) {
          for (var s in this.listcs) {
            if (this.listcs[s]["messageState"] == "发送通知") {
              num += this.listcs[s]["personal_number"] + ",";
            }
          }
        } else {
          return;
        }
      }
      num = num.substring(0, num.length - 1);
      var params_json = {
        userid: this.code,
        action: "notice",
        param1: num,
        param2: flg,
        param3: "",
        param4: "",
        param5: "",
      };
      this.$http.post("/web/save", params_json).then(function (res) {
        let obj = res.data;
        if (obj.msg == "0") {
          this.$notify({
            type: "success",
            message: "一键发送通知成功!",
          });
          this.init();
        } else {
          this.$notify({
            type: "warning",
            message: "一键发送通知失败!",
          });
          this.init();
        }
      });
    },
  },
};
</script>